import React, { useState } from 'react';
import { makeStyles } from '@material-ui/styles';
import { Grid, Typography, Divider } from '@material-ui/core';
import SectionTitle from '../components/SectionTitle'
import { Header, Experience, Headlines } from './components';
import ExperienceData from './components/Experience/ExperienceData';
import HeadlinesData from './components/Headlines/HeadlinesData';
import uuid from 'uuid/v1';
import Grow from '@material-ui/core/Grow';
import OwlCarousel from 'react-owl-carousel';
import 'owl.carousel/dist/assets/owl.carousel.css';
import 'owl.carousel/dist/assets/owl.theme.default.css';
import Fade from '@material-ui/core/Fade';


const useStyles = makeStyles(theme => ({
  root: {
    [theme.breakpoints.up('xs')]: {
      padding: '3% 7% 0% 7%'
    },
    [theme.breakpoints.down('xs')]: {
      padding: '16% 10% 0% 10%'
    }
  },
  content: {
    marginTop: '1%',
  },
  whatIDo: {
    marginLeft: 20,
    color: '#404040',
    fontSize: '1.8rem',
    fontWeight: 600
  },
  whatIDoDescription: {
    fontSize: 16,
    color: '#4e4e4e',
    marginBottom: '5vh'
  },
  divider: {
    marginTop: '5vh',
    marginBottom: '-5vh',
    backgroundColor: "#e4e4e4"
  }
}));

const AboutMe = () => {
  window.scrollTo(0, 0)
  const classes = useStyles()
  const [experiences] = useState(ExperienceData)
  const [headlines] = useState(HeadlinesData)
  return (
    <div className={classes.root}>
      <Header />
      <Divider className={classes.divider} />
      <SectionTitle title={'My skills'} />
      <Fade in={true} timeout={700}>
        <Typography className={classes.whatIDoDescription}>I have more than 3 years' experience building software for clients. Below is a quick overview of my main technical skill sets and technologies I use. Want to find out more about my experience? Check out my online resume and project portfolio.</Typography>
      </Fade>
      <Grow in={true}>
        <div className={classes.content}>
          <Grid
            container
            spacing={3}
          >
            {experiences.map(experience => (
              <Grid
                item
                key={uuid()}
                xl={3}
                lg={3}
                md={6}
                sm={6}
                xs={12}
              >
                <Experience experience={experience} />
              </Grid>
            ))}
          </Grid>
        </div>
      </Grow>
      <Divider className={classes.divider} />
      <SectionTitle title={'Headlines'} />
      <Grow in={true} >
        <OwlCarousel
          className="owl-theme"
          loop={true}
          // style={{justifyContent: 'center', display: 'flex'}}
          center={true}
          dots={true}
          autoplay={true}
          margin={15}
          responsive={{
            0: {
              items: 1
            },
            600: {
              items: 2
            },
            1000: {
              items: 3
            },
            1300: {
              items: 3
            }
          }}
        >
          {headlines.map(headline => (
            <div className="item" style={{ padding: '15px 15px 15px 15px' }} key={uuid()}>
              <Grid
                container
                spacing={3}
                key={uuid()}
              >
                <Headlines headline={headline} />
              </Grid>
            </div>
          ))}
        </OwlCarousel>
      </Grow>
    </div>
  );
};


export default AboutMe;